import React, { Component } from "react";
import ReactDOM from "react-dom";

import {
  SearchBarContainer,
  ToolbarContainer
} from "@c/users-view/MainContent.styled";
import {
  NavigationContainer,
  NavigationHeaderContainer,
  NavigationToolbar
} from "@sc/NavigationBar.styled";
import { Link } from "react-router-dom";
import { connectStore } from "redux-box";
import { module as activity } from "store/activity";
import { module as inviteCode } from "store/inviteCode";
import {
  OptionContainer
} from "../../story-view/story-view-header/StoryViewHeader.styled";
import {
  FilterDropDownMainContainer
} from "@sc/custom.styled";
import {
  MCQCheckBoxContainer,
  MCQCheckBoxInnerContainer,
} from "@sc/McqEditor.styled";


// export default connectStore({
//   activity
// })
// export default
class ActivityViewHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchBarEnable: false,
      navigationSelector: false,
      displayMenu: false,
      activityLanguage: "",
    };
  }

  componentDidMount() {
    let currentPath = window.location.pathname;
    if (currentPath.includes("/activities/packs")) {
      this.setState({
        navigationSelector: true,
      });
    } else {
      this.setState({
        navigationSelector: false,
      });
    }
    document.addEventListener("click", this.handleFilterClick);
  }
  handleNavigationSelector = (val) => {
    this.setState({
      navigationSelector: val,
    });
  };

  handleActivitiesSearch = (e) => {
    let { activity } = this.props;
    if (activity.enableOrder) activity.enableReorder(false);
    activity.setActivitySearch(e.target.value);
    setTimeout(() => {
      if (this.props.activity.active_grade !== null)
        this.props.activity.requestActivitiesByGrade(activity.active_grade);
    }, 1500);
  };

  handleActivityPacksSearch = (evt) => {
    //let activity=this.props;
    this.props.activity.setActivityPacksSearch(evt.target.value);
    setTimeout(() => {
      this.props.activity.requestActivityPacks();
    }, 1500);
  };

  enableSearchBar = (actionType) => {
    if (actionType === "focus" && this.state.searchBarEnable === false)
      this.setState({
        searchBarEnable: true,
      });
    else if (actionType === "blur" && this.state.searchBarEnable === true)
      this.setState({
        searchBarEnable: false,
      });
  };
  handleClearSearch = () => {
    let { activity } = this.props;

    activity.setActivitySearch("");
    activity.requestActivitiesByGrade(activity.active_grade);
  };

  handleClearPackSearch = () => {
    let { activity } = this.props;

    activity.setActivityPacksSearch("");
    activity.requestActivitiesByGrade(activity.active_grade);
  };

  setActivityLanguage = (value) => {
    this.setState({
      activityLanguage: value,
      displayMenu: false,
    });
    this.props.activity.setActivityLanguage(value);
    console.log(this.props.activity);
    if (window.location.pathname.includes("/activities/packs")) {
      this.props.activity.requestActivityPacks();
    } else {
      if (this.props.activity.active_grade) {
        this.props.activity.requestActivitiesByGrade(
          this.props.activity.active_grade
        );
      }
    }
  };

  displayMenu = () => {
    this.setState({
      displayMenu: !this.state.displayMenu,
    });
  };

  componentWillUnmount() {
    document.removeEventListener("click", this.handleFilterClick);
  }

  handleFilterClick = (evt) => {
    const area = ReactDOM.findDOMNode(this.refs.area);
    // console.log('wooo', area);
    if (!area.contains(evt.target) && this.state.displayMenu) {
      //console.log(area);
      this.setState({
        displayMenu: false,
      });
    }
  };

  render() {
    let currentPath = window.location.pathname;
    return (
      <NavigationHeaderContainer>
        <NavigationContainer>
          <Link
            to="/activities"
            className={this.state.navigationSelector === false ? "active" : ""}
            onClick={() => this.handleNavigationSelector(false)}
          >
            Activities
          </Link>
          <Link
            to={
              "/activities/packs/" +
              this.props.activity.active_grade_level +
              "/" +
              this.props.activity.active_level
            }
            className={this.state.navigationSelector === true ? "active" : ""}
            onClick={() => this.handleNavigationSelector(true)}
          >
            Activity Packs
          </Link>
        </NavigationContainer>
        <NavigationToolbar>
          {
            // !window.location.pathname.includes('/activities/packs') &&
            <div className="mx-2 my-1" style={{ width: "fit-content" }}>
              <ToolbarContainer>
                <div
                  style={{ display: "inline-block", position: "relative" }}
                  onBlur={this.displayMenu}
                  ref="area"
                >
                  <i
                    className="fa fa-filter btn btn-warning text-white p-2"
                    style={{ background: "#cb5499", borderColor:'#cb5499' }}
                    onClick={this.displayMenu}
                  />
                  {this.state.displayMenu ? (
                    <FilterDropDownMainContainer
                      onBlur={this.displayMenu}
                      tabIndex="0"
                    >
                      <ul>
                        {/* UI for story language */}
                        <li>
                          {" "}
                          <i className="fa fa-file-o px-1" />{" "}
                          <b> Activity language </b>
                          <ul>
                            <div
                              style={{
                                backgroundColor: "white",
                                marginRight: "2px",
                                minHeight: "130px",
                                minWidth: "100px",
                                overflowY: "auto",
                                boxShadow: "0px 3px 10px -2px rgba(0,0,0,0.5)",
                              }}
                            >
                              <li>
                                <OptionContainer
                                  onClick={() => this.setActivityLanguage("")}
                                >
                                  {" "}
                                  All{" "}
                                  <MCQCheckBoxContainer
                                    onClick={() => this.setActivityLanguage("")}
                                  >
                                    {this.state.activityLanguage === "" ? (
                                      <MCQCheckBoxInnerContainer />
                                    ) : null}
                                  </MCQCheckBoxContainer>
                                </OptionContainer>
                              </li>
                              {this.props.inviteCode &&
                                this.props.inviteCode.languages &&
                                this.props.inviteCode.languages.length > 0 &&
                                this.props.inviteCode.languages.map((lang) => (
                                  <li key={lang.id}>
                                    <OptionContainer
                                      onClick={() =>
                                        this.setActivityLanguage(lang.id)
                                      }
                                    >
                                      {lang.name}

                                      <MCQCheckBoxContainer>
                                        {this.state.activityLanguage ===
                                        lang.id ? (
                                          <MCQCheckBoxInnerContainer />
                                        ) : null}
                                      </MCQCheckBoxContainer>
                                    </OptionContainer>
                                  </li>
                                ))}
                            </div>
                          </ul>
                        </li>
                        {/* UI for story language */}
                      </ul>
                    </FilterDropDownMainContainer>
                  ) : null}
                </div>
                {/* <img src={require("static/img/scroll_right.png")} alt="ScrollRight" onClick={this.displayMenu} /> */}
              </ToolbarContainer>
            </div>
          }
          <SearchBarContainer
            width={this.state.searchBarEnable ? "300px" : "200px"}
          >
            <i className="fa fa-search" />
            {currentPath.includes("/activities/packs/Level") ? (
              <div>
                <input
                  type="text"
                  onChange={this.handleActivityPacksSearch}
                  placeholder="Search"
                  value={this.props.activity.search_pack_text}
                  onFocus={() => this.enableSearchBar("focus")}
                  onBlur={() => this.enableSearchBar("blur")}
                />
                {/* {this.props.activity.search_pack_text.length > 0 && (
                  <i
                    className="fa fa-times cross"
                    onClick={() => this.handleClearPackSearch()}
                  />
                )} */}
              </div>
            ) : (
              <div>
                <input
                  type="text"
                  onChange={this.handleActivitiesSearch}
                  placeholder="Search"
                  value={this.props.activity.search_text}
                  onFocus={() => this.enableSearchBar("focus")}
                  onBlur={() => this.enableSearchBar("blur")}
                />
                {/* {this.props.activity.search_text.length > 0 && (
                    <i
                      className="fa fa-times cross"
                      onClick={() => this.handleClearSearch()}
                    />
                  )} */}
              </div>
            )}
          </SearchBarContainer>
          <ToolbarContainer>
            {/* <img src={require("static/img/filter.png")} alt="Filter" /> */}
            {/* <img
              src={require("static/img/scroll_right.png")}
              alt="Scroll Right"
            /> */}
          </ToolbarContainer>
        </NavigationToolbar>
      </NavigationHeaderContainer>
    );
  }
}

export default connectStore({
  activity,inviteCode
 })(ActivityViewHeader)